import { render, staticRenderFns } from "./oc-drawer.vue?vue&type=template&id=07c49518&scoped=true"
import script from "./oc-drawer.vue?vue&type=script&lang=js"
export * from "./oc-drawer.vue?vue&type=script&lang=js"
import style0 from "./oc-drawer.vue?vue&type=style&index=0&id=07c49518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c49518",
  null
  
)

export default component.exports